import { PLANS } from "../../../consts";

export const FreePlanConfig = {
  name: "FREE plan",
  description:
    "Essential features and starter quotas to explore and evaluate the platform risk-free.",
  livemode: false,
  marketing_features: [
    {
      name: "50 events",
    },
    {
      name: "3 months ahead",
    },
    {
      name: "1 widgets",
    },
    {
      name: "1 website",
    },
    {
      name: "200 views",
    },
    {
      name: "1 team member",
    },
  ],
  images: [],
  metadata: { app_plan_code: PLANS.free },
};

export const FreePlanPrice = {
  id: "freeplan",
  object: "price",
  active: true,
  billing_scheme: "per_unit",
  created: 1755694303,
  currency: "usd",
  custom_unit_amount: null,
  livemode: false,
  lookup_key: null,
  metadata: [],
  nickname: null,
  product: "freeplan",
  recurring: {
    aggregate_usage: null,
    interval: "month",
    interval_count: 1,
    meter: null,
    trial_period_days: null,
    usage_type: "licensed",
  },
  tax_behavior: "unspecified",
  tiers_mode: null,
  transform_quantity: null,
  type: "recurring",
  unit_amount: 0,
  unit_amount_decimal: "0",
};
